import { useEffect, useRef, useState } from 'react';

import { Img } from '../img/img';
import { streamLimiter } from './stream-limiter';

const test = false;

// Static image shown while a stream is queued (does NOT hold an MJPEG connection).
const PLACEHOLDER = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'%3E%3C/svg%3E"; // прозрачный 1x1 SVG

export const VideoUrl = (props) => {
  const { id, id1, createtime, func, className, realVideo = false } = props;
  const [n, setN] = useState(0);

  /**
   * get image src (the live MJPEG url)
   * @returns
   */
  const getImageSrc = () => {
    return test ? '/images/test/' + id + '.jpg?ct=' + createtime : props.src;
  };

  const realSrc = getImageSrc();

  // What is actually rendered. Starts as a placeholder; the limiter swaps in the
  // live MJPEG url only when this stream is granted one of the limited slots.
  const [activeSrc, setActiveSrc] = useState(PLACEHOLDER);
  const realSrcRef = useRef(realSrc);
  const activeRef = useRef(false);
  const mountedRef = useRef(false);

  // keep the latest live url so the limiter's activate() always uses it
  realSrcRef.current = realSrc;

  // if this stream currently owns a slot, propagate url changes (e.g. refresh)
  useEffect(() => {
    if (activeRef.current) {
      setActiveSrc(realSrc);
    }
  }, [realSrc]);

  /**
   * register with the global concurrency limiter so we never exceed the per-host
   * connection cap (see stream-limiter.js for the root-cause explanation)
   */
  useEffect(() => {
    mountedRef.current = true;

    const activate = () => {
      activeRef.current = true;
      setActiveSrc(realSrcRef.current);
    };
    const deactivate = () => {
      activeRef.current = false;
      // switching to a static image aborts the live MJPEG connection and frees the slot
      setActiveSrc(PLACEHOLDER);
    };

    streamLimiter.register(id1, activate, deactivate);

    return () => {
      mountedRef.current = false;
      streamLimiter.release(id1);
      // make sure the connection is torn down when the window/stream unmounts
      const el = document.getElementById(id1);
      if (el && el.src) {
        el.src = '';
      }
    };
  }, [id1]);

  /**
   * set active cam. Also bump this stream's priority so an interacted/focused
   * stream can preempt an older one when we are over the connection limit.
   */
  const setActiveCam = () => {
    streamLimiter.touch(id1);
    func(id);
  };

  const cl = (className ?? '') + (realVideo ? ' real-video' : '') + ' simple';
  
  const reload = () => {
    if (mountedRef.current && activeRef.current) {
      setN((v) => v + 1);
    }
  };

  return (
    <Img
      key={n}
      draggable="false"
      onDragStart={() => false}
      id={id1}
      className={cl}
      src={activeSrc}
      onClick={setActiveCam}
      afterError={reload}
      realVideo={realVideo}
    />
  );
};
